<template>
  <div v-if="item && showRhinoRackStock">
    <div v-if="isFetchCompleted" :class="enabled == true ? 'pricing_header row cursor_pointer' : 'pricing_header row'" v-on:click="toggleOpen = !toggleOpen">
      <div :class="enabled == true ? 'left col-6' : 'left col-12'" v-if="prices && prices.length && prices.length == 1 && !cartNoAccess">
        <b>{{ label_stock_availability }}</b>
        <div class="availability" :class="availabilityAU ? stockAvailabilityClassAU() : stockAvailabilityClass(item)"></div>
        {{ availabilityAU ? stockAvailabilityAU() : stockAvailability(item) }}
      </div>
      <div :class="enabled == true ? 'left col-6' : 'left col-12'" v-if="prices && prices.length && prices.length > 1 && !cartNoAccess">
        <b>{{ label_stock_availability }}</b>
        <div class="availability" :class="availabilityAU ? stockAvailabilityClassAU() : stockAvailabilityClassItems(prices)"></div>
        {{ availabilityAU ? stockAvailabilityAU() : stockAvailabilityItems(prices) }}
      </div>
      <div :class="enabled == true ? 'left col-6' : 'left col-12'" v-if="prices && prices.length && cartNoAccess">
        <b>Your Pricing</b>
      </div>
      <div class="right col-6" v-if="item_price > 0 && userType == 'B2B' && item" >
        <span v-if="!toggleOpen">{{ label_expand }}</span> <i class="icon icon-down" v-if="!toggleOpen"></i><i class="icon icon-up" v-if="toggleOpen"></i>
      </div>
    </div>

    <div class="pricing_body row" v-if="item_price > 0 && toggleOpen && userType == 'B2B' && item">
      <div class="col-12 price_title" v-if="!priceschedule.length">
        <b>{{ formatNumber(item_price) }} {{ getPriceSuffix }}</b>
      </div>
      <div v-if="!noBulkBuyDiscount">
        <div class="col-12 price_title" v-if="priceschedule.length">
          <b>{{ label_product_price_breakdown }}</b>
        </div>
        <div class="price_item" :class="getPriceCountClass(priceschedule)" v-for="(item, index) in priceschedule" :key="index">
          <div class="ranges">{{ item.minimumquantity }}{{ item.maximumquantity == '+' ? '+' : "-" + item.maximumquantity }}</div>
          <div class="values">{{ formatNumber(item.price) }} {{ getPriceSuffix }}</div>
        </div>
      </div>
      <div v-if="noBulkBuyDiscount">
        <div class="values">{{ formatNumber(priceschedule[0].price) }} {{ getPriceSuffix }}</div>
      </div>
      <div class="estimate">{{ label_estimated }}</div>
    </div>
    <out-of-stock-notification :product-id="product_id" :sitekey="sitekey" :item="item"  v-if="((!item ||!item.isinstock || areComponentsOutOfStock ) && !isAlwaysInStock )&& isWaitListActive"></out-of-stock-notification>
  </div>
</template>

<style scoped>
  .pricing_header {
    background-color: #EAEAEA;
    border: 1px solid #D3D3D3;
    padding: 10px 0px;

  }
  .cursor_pointer{
    cursor: pointer;
  }
  .pricing_body {
    border: 1px solid #D3D3D3;
    margin-top: -1px;
  }
  .pricing_header .right {
    text-align: right;
  }
  .pricing_header i {
    font-size: 10px;
    vertical-align: middle;
  }
  .availability {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 5px;
  }
  .in_store {
    background-color: green;
  }

  .available_for_backorder {
    background-color: darkorange;
  }
  .out_of_stock {
    background-color: darkred;
  }
  .ranges {
    background-color: #F1F1F1;
    font-weight: bold;
  }
  .items_1 {
    width: 100%;
    float: left;
  }
  .items_2, .items_4, .items_5 {
    width: 50%;
    float: left;
  }
  .items_3, .items_6 {
    width: 33.33333%;
    float: left;
  }
  .ranges, .values {
    padding: 7px 15px;
    text-align: center;
  }
  .price_title {
    padding: 7px 15px;
  }
  .estimate {
    padding: 4px 15px;
    color: #555;
    font-size: 13px;
  }
</style>

<script>

  import OutOfStockNotification from "../out-of-stock-notification.vue";

  export default {
    name: "dealer-pricing",
    data() {
      return {
        enabled: false,
        prices: [],
        item_price: 0,
        priceschedule: [],
        item: null,
        availabilityAU : null,
        ns_session_var: window.ns_session_var,
        tax: window.tax,
        currency: window.currency,
        culture: window.culture,
        country: window.country,
        toggleOpen: false,
        areComponentsOutOfStock: false,
        locId: 25,
        regionId: 7,
        product_category: '',
        isFetchCompleted: false,
        auStockValue: 0,
        test_data: 'testing',
      };
    },
    components: {
      OutOfStockNotification
    },
    props: {
      sitekey:{
        type: String
      },
      netsuite_url: {
        type: String
      },
      netsuite_parent_id :{
        type: String,
      },
      netsuite_parent_id_new :{
        type: String,
      },
      netsuite_id: {
        type: String
      },
      package_components: {
        type: String
      },
      parent_status: {
        type: String
      },
      parent_isinstock: {
        type: String
      },
      parent_isbackorderable: {
        type: String
      },
      childactivestatus: {
        type: String
      },
      childbackorderablestatus: {
        type: String
      },
      product_id: {
        type: String
      },
      item_brand: {
        type: String,
        default: "Rhinorack"
      },
      components: {
        type: Array
      },
      product_title: {
        type: String
      },
      category: {
        type: Object
      },
      price: {
        type: Number,
        required: true
      },
      stockCode: {
        type: String
      },
      stock_code_new: {
        type: String
      },
      is_stock_waitlist_active: {
        type: String
      },
      is_spare_part_enabled: {
        type: String
      },
      is_always_in_stock: {
        type: String
      },
      label_stock_availability: {
        type: String,
        default: "Stock Availability"
      },
      label_in_stock: {
        type: String,
        default: "In Stock"
      },
      label_available_for_backorder: {
        type: String,
        default: "Available for Backorder"
      },
      label_out_of_stock: {
        type: String,
        default: "Out of Stock – Call for info"
      },
      label_expand: {
        type: String,
        default: "Expand for dealer pricing"
      },
      label_product_price_breakdown: {
        type: String,
        default: "Product Price Breakdown"
      },
      label_estimated: {
        type: String,
        default: "Prices are estimated, further discounts may apply at checkout."
      },
      ga_tracking_category: {
        type: String,
        default: "view_item"
      },
    },
    mounted(){
      this.filterCategory();
      this.setRegionIds();
      this.loadPricing();
      this.isFetchCompleted = true;
    },
    computed: {
      userType() {
        var ret = this.$store.getters["auth/userType"];
        if (!this.enabled) {
          this.enabled = true;
        }
        return ret;
      },
      cartUrl() {
        var t = parseInt(Date.now() / 1000);
        if (this.components && this.components.length == 0) {
          return this.netsuite_url + "api/items?&include=facets&pricelevel=5&c=" + this.ns_session_var + "&fieldset=details&n=2&region=" + this.regionId + "&currency=" + this.currency + "&id=" + this.netsuite_id + `&t=` + t;
        } else {
          var ids = this.components.map((item, index) => {
            return item.product.netSuiteId;
          });
          ids.push(this.netsuite_id);
          return this.netsuite_url + "api/items?&include=facets&pricelevel=5&c=" + this.ns_session_var + "&fieldset=details&n=2&region=" + this.regionId + "&currency=" + this.currency + "&id=" + ids.join(',') + `&t=` + t;
        }
      },
      cartUrlAU() {
        let t = parseInt(Date.now() / 1000);
        if (this.components && this.components.length == 0) {
          return "https://4073460.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=1944&deploy=1&compid=4073460&ns-at=AAEJ7tMQUQJ0VcvlpO7CweYXHyQVBn_B3XmhjJL5r7rXvV8Xp6A" +
        "&itemId=" + + this.netsuite_id + '&locId=' + this.locId + '&state=' + this.$store.state.auth.profile.address_state + `&t=` + t;
        } else {
          return "https://4073460.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=1944&deploy=1&compid=4073460&ns-at=AAEJ7tMQUQJ0VcvlpO7CweYXHyQVBn_B3XmhjJL5r7rXvV8Xp6A" +
        "&itemId=" + this.netsuite_parent_id + '&locId=' + this.locId + '&state=' + this.$store.state.auth.profile.address_state + `&t=` + t;
        }
      },
      cartUrlChildComponentsAU() {
        let t = parseInt(Date.now() / 1000);
        return "https://4073460.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=1944&deploy=1&compid=4073460&ns-at=AAEJ7tMQUQJ0VcvlpO7CweYXHyQVBn_B3XmhjJL5r7rXvV8Xp6A" +
        "&itemId=" + this.netsuite_parent_id + '&locId=' + this.locId + '&state=' + this.$store.state.auth.profile.address_state + `&t=` + t;
      },
      cartNoAccess() {
        return false; // RRI-817 Temp Fix this.$store.getters["auth/cartNoAccess"];
      },
      isWaitListActive() {
        return Boolean(Number(this.is_stock_waitlist_active));
      },
      isAlwaysInStock() {
        return this.is_always_in_stock ? Boolean(Number(this.is_always_in_stock)) : false;
      },
      showRhinoRackStock() {
        return this.$store.getters["auth/showRhinoRackStock"];
      },
      noBulkBuyDiscount() {
        return this.$store.getters["auth/noBulkBuyDiscount"];
      },
      getPriceSuffix() {
        if(["en-au", "en-nz"].includes(this.culture)) {
          return "(Inc GST)";
        }
        return "";
      }
    },
    methods: {
      filterCategory(){
        if (this.category && this.category.title) {
          this.product_category = this.category.title;
        }
      },
      setRegionIds(){
        if (window.culture == 'en-nz') {
          this.locId = 16;
          this.regionId = 5;
        }
        if ((window.culture == 'en-us') || (window.culture == 'es-us')) {
          this.locId = 4;
          this.regionId = 4;
        }
      },
      async fetchAvailabilityForAU() {

        if (this.netsuite_parent_id) {
          let responseChildComponentsAU = await axios.get(this.cartUrlChildComponentsAU, { withCredentials: true });
          if (typeof responseChildComponentsAU.data.components === "object") {
            this.$store.commit('cart/setComponentsStockAvailabilityAU', Object.entries(responseChildComponentsAU.data.components));
          }
        }

        let responseAU = await axios.get(this.cartUrlAU, { withCredentials: true });
        let availabilityAU = responseAU.data.stockStatus;

        this.availabilityAU = availabilityAU;
      },
      getPriceCountClass(prices) {
        return "items_" + prices.length;
      },
      stockAvailability(item) {
        var ret = this.$store.getters["auth/userType"];
        this.$store.commit('outofstock/setSparePartAvailability',
                { isOnlineSparePartEnabled: this.isSparePartEnabled(), hasOnlineSparePart: item.custitem_onlinesparepart });

        if(window.culture == 'en-au' || window.culture == 'en-nz'){
          if(this.isAlwaysInStock && ((window.culture == 'en-us') || (window.culture == 'es-us'))) {
            return this.label_available_for_backorder;
          } else if (item.isinstock  === true) {
            return this.label_in_stock;
          } else if (item.isinstock === false && item.isbackorderable  === true  && ret == 'B2B') {
            return this.label_available_for_backorder;
          } else {
            return this.label_out_of_stock;
          }
        }else{
          if(this.parent_status == 'null'){
            if((this.parent_isinstock == '0' && this.parent_isbackorderable == '0')){
              return this.label_out_of_stock;
            }
            else if(this.parent_isinstock == '1'){
              return this.label_in_stock;
            }
            else if(this.parent_isinstock == '0' && this.parent_isbackorderable == '1' && ret == 'B2B'){
              return this.label_available_for_backorder;
            }
            else{
              return this.label_out_of_stock;
            }
          }
          else if(this.parent_status == 'out_of_stock' || (window.culture == 'en-nz' && item.custitemweb_item_not_for_sale_wel == true) || (window.culture == 'en-au' && item.custitemweb_item_not_for_sale_syd == true) ||((window.culture == "en-us" || window.culture == "en-es") && item.custitemweb_item_not_for_sale_den == true)  ){
            return this.label_out_of_stock;
          }
          else if(this.parent_status == 'is_backorderable'  && ret == 'B2B'){
            return this.label_available_for_backorder;
          }
          else if(this.parent_status == 'is_in_stock'){
            return this.label_in_stock;
          }else{
            return this.label_out_of_stock;
          }
        }
      },
      stockAvailabilityItems(items)
      {
        let ret = this.$store.getters["auth/userType"];
        var isinstock = true, isbackorderable = true, custitemweb_item_not_for_sale_wel = true, custitemweb_item_not_for_sale_syd = true, custitemweb_item_not_for_sale_den= true;
        if(window.culture == 'en-au' || window.culture == 'en-nz'){
          if (isinstock === true){
            return this.label_in_stock;
          }
          else if (isinstock === false && isbackorderable === true && ret == 'B2B'){
            return this.label_available_for_backorder;
          }
          else{
            this.areComponentsOutOfStock = true;
            return this.label_out_of_stock;
          }
        }

        for (var i = 0; i < items.length; i++) {
          isinstock =  items[i].isinstock;
          isbackorderable = items[i].isbackorderable;
          custitemweb_item_not_for_sale_wel = items[i].custitemweb_item_not_for_sale_wel;
          custitemweb_item_not_for_sale_syd = items[i].custitemweb_item_not_for_sale_syd;
          custitemweb_item_not_for_sale_den = items[i].custitemweb_item_not_for_sale_den;
        }
        if(this.parent_status == 'null'){
          if((this.parent_isinstock == '0' && this.parent_isbackorderable == '0')){
            return this.label_out_of_stock;
          }
          else if(this.parent_isinstock == '1'){
            return this.label_in_stock;
          }
          else if(this.parent_isinstock == '0' && this.parent_isbackorderable == '1' && ret == 'B2B'){
            return this.label_available_for_backorder;
          }
          else{
            return this.label_out_of_stock;
          }
        }
        else if(this.parent_status == 'out_of_stock' || (window.culture == 'en-nz' && custitemweb_item_not_for_sale_wel == true) || (window.culture == 'en-au' && custitemweb_item_not_for_sale_syd == true) ||((window.culture == "en-us" || window.culture == "en-es") && custitemweb_item_not_for_sale_den == true)  ){
          return this.label_out_of_stock;
        }
        else if(this.parent_status == 'is_backorderable'  && ret == 'B2B'){
          return this.label_available_for_backorder;
        }
        else if(this.parent_status == 'is_in_stock'){
          return this.label_in_stock;
        }else{
          return this.label_out_of_stock;
        }

      },
      stockAvailabilityClass(item)
      {
        var ret = this.$store.getters["auth/userType"];

        if(window.culture == 'en-au' || window.culture == 'en-nz'){
          if(this.isAlwaysInStock && ((window.culture == 'en-us') || (window.culture == 'es-us'))) {
            return 'available_for_backorder';
          } else if (item.isinstock === true ) {
            return 'in_store';
          } else if (item.isinstock === false && item.isbackorderable === true  && ret == 'B2B') {
            return 'available_for_backorder';
          } else {
            return 'out_of_stock';
          }
        }

        if(this.parent_status == 'null'){
          if((this.parent_isinstock == '0' && this.parent_isbackorderable == '0')){
            return 'out_of_stock';
          }
          else if(this.parent_isinstock == '1'){
            return 'in_store';
          }
          else if(this.parent_isinstock == '0' && this.parent_isbackorderable == '1' && ret == 'B2B'){
            return 'available_for_backorder';
          }
          else{
            return 'out_of_stock';
          }
        }
        else if(this.parent_status == 'out_of_stock' || (window.culture == 'en-nz' && item.custitemweb_item_not_for_sale_wel == true) || (window.culture == 'en-au' && item.custitemweb_item_not_for_sale_syd == true) ||((window.culture == "en-us" || window.culture == "en-es") && item.custitemweb_item_not_for_sale_den == true)  ){
          return 'out_of_stock';
        }
        else if(this.parent_status == 'is_backorderable'  && ret == 'B2B'){
          return 'available_for_backorder';
        }
        else if(this.parent_status == 'is_in_stock'){
          return 'in_store';
        }else{
          return 'out_of_stock';
        }

      },
      stockAvailabilityClassItems(items) {
        var ret = this.$store.getters["auth/userType"];
        var isinstock = true, isbackorderable = true, custitemweb_item_not_for_sale_wel = true, custitemweb_item_not_for_sale_syd = true, custitemweb_item_not_for_sale_den= true;

        if(window.culture == 'en-au' || window.culture == 'en-nz'){
          if (isinstock  === true ) {
            return 'in_store';
          } else if (isinstock === false && isbackorderable  === true  && ret == 'B2B') {
            return 'available_for_backorder';
          } else {
            return 'out_of_stock';
          }
        }

        for (var i = 0; i < items.length; i++) {
          isinstock =  items[i].isinstock;
          isbackorderable = items[i].isbackorderable;
          custitemweb_item_not_for_sale_wel = items[i].custitemweb_item_not_for_sale_wel;
          custitemweb_item_not_for_sale_syd = items[i].custitemweb_item_not_for_sale_syd;
          custitemweb_item_not_for_sale_den = items[i].custitemweb_item_not_for_sale_den;
        }
        if(this.parent_status == 'null' && window.culture != 'en-au'){
          if((this.parent_isinstock == '0' && this.parent_isbackorderable == '0')){
            return 'out_of_stock';
          }
          else if(this.parent_isinstock == '1'){
            return 'in_store';
          }
          else if(this.parent_isinstock == '0' && this.parent_isbackorderable == '1' && ret == 'B2B'){
            return 'available_for_backorder';
          }
          else{
            return 'out_of_stock';
          }
        }
        else if(this.parent_status == 'out_of_stock' || (window.culture == 'en-nz' && custitemweb_item_not_for_sale_wel == true) || (window.culture == 'en-au' && custitemweb_item_not_for_sale_syd == true) ||((window.culture == "en-us" || window.culture == "en-es") && custitemweb_item_not_for_sale_den == true)  ){
          return 'out_of_stock';
        }
        else if(this.parent_status == 'is_backorderable'  && ret == 'B2B'){
          return 'available_for_backorder';
        }
        else if(this.parent_status == 'is_in_stock'){
          return 'in_store';
        }else{
          return 'out_of_stock';
        }

      },
      stockAvailabilityAU() {
        if (this.availabilityAU == 'IN_STOCK') {
          return this.label_in_stock;
        } else if (this.availabilityAU == 'BACKORDER' && this.userType == 'B2B') {
          return this.label_available_for_backorder;
        }
        else if (this.availabilityAU == 'CUSTOM_BUILD' || this.availabilityAU == 'OUT_OF_STOCK') {
          return this.label_out_of_stock;
        }
        else{
          return this.label_out_of_stock;
        }

      },
      stockAvailabilityClassAU() {
        if (this.availabilityAU == 'IN_STOCK') {
          return 'in_store';
        } else if (this.availabilityAU == 'BACKORDER' && this.userType == 'B2B') {
          return 'available_for_backorder';
        } else if (this.availabilityAU == 'CUSTOM_BUILD' || this.availabilityAU == 'OUT_OF_STOCK') {
          return 'out_of_stock';
        }else{
          return 'out_of_stock';
        }
      },
      applyTax(num) {
        if (['au', 'AU', 'nz', 'NZ'].indexOf(this.country) > -1) {
          return num;
        } else {
          return num * this.tax;
        }
      },

      formatNumber(num) {
        num = this.applyTax(num);
        return new Intl.NumberFormat(this.culture, { style: 'currency', currency: this.currency }).format(num);
      },
      async loadPricing() {
        let apiData = await axios.get(this.cartUrl, { withCredentials: true });
        this.prices = apiData.data.items;
        if (this.prices.length == 1) {
          if (this.prices[0].onlinecustomerprice_detail) {
            this.item_price = this.prices[0].onlinecustomerprice_detail.onlinecustomerprice;
            if (this.prices[0].onlinecustomerprice_detail.priceschedule) {
              if (this.prices[0].onlinecustomerprice_detail.priceschedule.length == 2) {
                this.prices[0].onlinecustomerprice_detail.priceschedule[1].maximumquantity = '+';
              }
              this.priceschedule = this.prices[0].onlinecustomerprice_detail.priceschedule;
            }
          }
          this.item = this.prices[0];
        } else {
          this.item_price = 0;
          this.priceschedule = [];
          var itemPrices = [];
          var priceRanges = [];
          for (var i = 0; i < this.prices.length; i++) {
            if (this.prices[i].internalid == this.netsuite_id) {
              this.item = this.prices[i];
            } else {
              for (var ii = 0; ii < this.components.length; ii++) {
                if (this.prices[i].internalid == this.components[ii].product.netSuiteId) {
                  this.item_price = this.item_price + (this.prices[i].onlinecustomerprice_detail.onlinecustomerprice * this.components[ii].qty);
                  if (this.prices[i].onlinecustomerprice_detail.priceschedule) {
                    for (var iii = 0; iii < this.prices[i].onlinecustomerprice_detail.priceschedule.length; iii++) {
                      var item = this.prices[i].onlinecustomerprice_detail.priceschedule[iii];
                      item.qty = this.components[ii].qty
                      itemPrices.push(item);
                      priceRanges[item.minimumquantity] = item.minimumquantity;
                      priceRanges[item.maximumquantity || '+'] = item.maximumquantity || '+';
                    }
                  } else {
                    itemPrices.push({minimumquantity: 0, price: this.prices[i].onlinecustomerprice_detail.onlinecustomerprice, qty: this.components[ii].qty});
                  }
                }
              }
            }
          }
          var keys = Object.keys(priceRanges);
          for (var pi = 0; pi < keys.length - 1; pi++) {
            var priceRangeItem = {
              minimumquantity: keys[pi],
              maximumquantity: keys[pi + 1],
              price: 0,
              items: []
            }
            for (var ip = 0; ip < itemPrices.length; ip++) {
              if (itemPrices[ip].minimumquantity <= keys[pi] && (itemPrices[ip].maximumquantity >= keys[pi + 1] || !itemPrices[ip].maximumquantity)) {
                priceRangeItem.price = priceRangeItem.price + (itemPrices[ip].price * itemPrices[ip].qty);
                priceRangeItem.items.push(itemPrices[ip])
              }
            }
            this.priceschedule.push(priceRangeItem);
          }
        }
      },
      isSparePartEnabled() {
        return Boolean(Number(this.is_spare_part_enabled));
      }
    }
  };
</script>


